<template>
  <div v-if="errInfo">
    <img class="empty-img" :src="getImageUrl()" alt="" />
    <P v-if="errInfo.msg" class="empty-tips">{{ errInfo.msg }}</P>
    <div v-if="errInfo.btnText" class="empty-btn" @click="clickBtn">{{ errInfo.btnText }}</div>
  </div>
</template>
<script>
export default {
  props: ["errInfo"],

  methods: {
    clickBtn() {
      this.$emit("errBtnClickCallback")
    },

    getImageUrl() {
      return require(`../../../../ui/assets/mobile/images/empty-backpack${this.errInfo.type || 2}.png`)
    }
  }
}
</script>
